import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const items = [
  { to: '/',               icon: '⬡', label: 'Главная' },
  { to: '/monitoring',     icon: '◈', label: 'Мониторинг' },
  { to: '/orders-regions', icon: '◎', label: 'Заказы по регионам' },
  { to: '/redistribution', icon: '⟳', label: 'Перераспределение' },
  { to: '/ff-task',        icon: '◫', label: 'Подсорт (ТЗ для ФФ)' },
  { to: '/advertising',    icon: '◈', label: 'Реклама' },
  { to: '/sales-funnel',    icon: '🔻', label: 'Воронка продаж' },
  { to: '/ai-analytics',   icon: '⬡', label: 'AI Аналитика' },
  { to: '/hypothesis', icon: '📅', label: 'Гипотезы' },
  { to: '/strategy',   icon: '◎', label: 'Стратегия' },
  { to: '/unit-economics', icon: '₿', label: 'Юнит-экономика' },
  { to: '/audit', icon: '🔍', label: 'Аудит карточки' },
  { to: '/reviews', icon: '◆', label: 'Отзывы' },
];
const bottomItems = [
  { to: '/settings', icon: '◎', label: 'Настройки' },
  { to: '/profile',  icon: '◈', label: 'API токены' },
  { to: '/import',   icon: '◫', label: 'Импорт данных' },
  { to: '/info',     icon: '◇', label: 'Информация' },
];

const SIDEBAR_W = 220;
const COLLAPSED_W = 0;

export default function Sidebar({ user, onLogout }) {
  const [open, setOpen] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const saved = localStorage.getItem('sidebar_open');
    if (saved !== null) setOpen(saved === 'true');
  }, []);

  const toggle = () => {
    setOpen(prev => {
      const next = !prev;
      localStorage.setItem('sidebar_open', String(next));
      window.dispatchEvent(new CustomEvent('sidebar-toggle', { detail: next }));
      return next;
    });
  };

  const linkStyle = (active) => ({
    display: 'flex', alignItems: 'center', gap: 10,
    padding: '9px 14px', borderRadius: 8, marginBottom: 1,
    textDecoration: 'none',
    fontSize: 12, fontWeight: active ? 600 : 400,
    letterSpacing: '0.2px',
    color: active ? '#ffffff' : 'rgba(210,225,245,0.8)',
    background: active ? 'rgba(59,130,246,0.12)' : 'transparent',
    borderLeft: `2px solid ${active ? '#3b82f6' : 'transparent'}`,
    transition: 'all 0.15s',
    whiteSpace: 'nowrap', overflow: 'hidden',
  });

  return (
    <>
      <div style={{
        width: open ? SIDEBAR_W : COLLAPSED_W,
        minHeight: '100vh',
        background: 'rgba(8,14,25,0.82)',
        backdropFilter: 'blur(24px)',
        WebkitBackdropFilter: 'blur(24px)',
        borderRight: '1px solid rgba(255,255,255,0.07)',
        display: 'flex', flexDirection: 'column',
        position: 'fixed', left: 0, top: 0, bottom: 0,
        transition: 'width 0.3s cubic-bezier(0.16,1,0.3,1)',
        overflow: 'hidden',
        zIndex: 100,
        boxShadow: '4px 0 24px rgba(0,0,0,0.3)',
      }}>
        <div style={{ position:'absolute', top:0, left:0, right:0, height:1, background:'linear-gradient(90deg,transparent,rgba(255,255,255,0.08),transparent)', pointerEvents:'none' }}/>

        <NavLink to="/" style={{ textDecoration:'none', display:'block', padding:'22px 18px 18px', borderBottom:'1px solid rgba(255,255,255,0.06)', flexShrink:0 }}>
          <div style={{ fontSize:20, fontWeight:800, letterSpacing:'-1px', whiteSpace:'nowrap' }}>
            <span style={{ color:'#ffffff' }}>by</span>
            <span style={{ color:'transparent', backgroundImage:'linear-gradient(135deg,#3b82f6,#93c5fd)', WebkitBackgroundClip:'text', backgroundClip:'text' }}>stats</span>
          </div>
          <div style={{ fontSize:10, color:'rgba(200,215,235,0.55)', marginTop:3, letterSpacing:'1.5px', textTransform:'uppercase' }}>
            Analytics
          </div>
        </NavLink>

        <nav style={{ flex:1, padding:'12px 8px', overflowY:'auto', overflowX:'hidden' }}>
          {items.map(item => (
            <NavLink key={item.to} to={item.to} end={item.to==='/'} style={({ isActive }) => linkStyle(isActive)}
              onMouseEnter={e => { if (!e.currentTarget.style.background.includes('0.12')) e.currentTarget.style.background='rgba(255,255,255,0.04)'; }}
              onMouseLeave={e => { if (!e.currentTarget.style.background.includes('0.12')) e.currentTarget.style.background='transparent'; }}>
              <span style={{ fontSize:14, flexShrink:0, opacity:0.9 }}>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div style={{ padding:'8px', borderTop:'1px solid rgba(255,255,255,0.06)', flexShrink:0 }}>
          {bottomItems.map(item => (
            <NavLink key={item.to} to={item.to} style={({ isActive }) => linkStyle(isActive)}
              onMouseEnter={e => { if (!e.currentTarget.style.background.includes('0.12')) e.currentTarget.style.background='rgba(255,255,255,0.04)'; }}
              onMouseLeave={e => { if (!e.currentTarget.style.background.includes('0.12')) e.currentTarget.style.background='transparent'; }}>
              <span style={{ fontSize:14, flexShrink:0, opacity:0.9 }}>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
          <div style={{ padding:'8px 14px 6px', marginTop:2 }}>
            <div style={{ fontSize:11, color:'rgba(200,215,235,0.5)', marginBottom:8, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis' }}>
              {user?.name || user?.email}
            </div>
            <button onClick={onLogout} style={{
              width:'100%', background:'rgba(239,68,68,0.08)',
              color:'rgba(239,68,68,0.8)', border:'1px solid rgba(239,68,68,0.15)',
              padding:'7px', fontSize:12, borderRadius:7, cursor:'pointer',
              transition:'all 0.15s', whiteSpace:'nowrap',
            }}
            onMouseEnter={e => e.currentTarget.style.background='rgba(239,68,68,0.15)'}
            onMouseLeave={e => e.currentTarget.style.background='rgba(239,68,68,0.08)'}>
              Выйти
            </button>
          </div>
            <div style={{ fontSize:10, color:"rgba(255,255,255,0.2)", textAlign:"center", marginTop:8, letterSpacing:"1px" }}>v1.0</div>
        </div>
      </div>

      <button onClick={toggle} style={{
        position: 'fixed',
        left: open ? SIDEBAR_W - 14 : 14,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 101,
        width: 28, height: 28,
        borderRadius: '50%',
        background: 'rgba(15,23,42,0.9)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(59,130,246,0.35)',
        color: '#60a5fa',
        fontSize: 13,
        cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 2px 12px rgba(0,0,0,0.4), 0 0 0 1px rgba(59,130,246,0.1)',
        transition: 'left 0.3s cubic-bezier(0.16,1,0.3,1), background 0.15s',
      }}
      onMouseEnter={e => e.currentTarget.style.background='rgba(59,130,246,0.2)'}
      onMouseLeave={e => e.currentTarget.style.background='rgba(15,23,42,0.9)'}>
        {open ? '‹' : '›'}
      </button>
    </>
  );
}
